export default __webpack_public_path__ + "static/media/lunarCat.d3394abf.png";